import { reactive,ref } from 'vue'

export const store = reactive({
  WebSocket: ref(null),
  loading: ref(false),
  data:{}
})